import { getSupaClient } from "../../lib/supabase";

/**
 * This is a test function that is being used by DiscordEditorSandBox.tsx, the purpose of this
 * function is to send a message quickly to test the Discord Editor.
 * @param path
 * @param method
 * @param payload
 */
async function sendMessage(
  path: string,
  method: "GET" | "POST" | "PUT",
  payload?: string
) {
  const supabase = getSupaClient();
  const session = await supabase.auth.session();
  const response = await fetch(`${process.env["REACT_APP_API_URL"]}${path}`, {
    method,
    headers: { Authorization: `Bearer ${session?.access_token}` },
    body: payload,
  });
  if (response.ok) {
    return "OK";
  } else {
    let reason;
    try {
      reason = (await response.json()).reason;
    } catch (e: any) {
      reason = e.message ?? JSON.stringify(e);
    }
    throw new Error(reason);
  }
}

export default sendMessage;
